const CaretDownPD2 = () => {


  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="CaretDownPD2Icon"
    
      id="CaretDownPD1IconId"
      style={{ width: "24px", height: "24px" }}
      fill="#000000"
      viewBox="0 0 256 256"
    >
      <rect width="256" height="256" fill="none"></rect>
      <polyline
        points="208 96 128 176 48 96"
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="16"
      ></polyline>
    </svg>
  );
};
export default CaretDownPD2;
